import { ElementRef } from "@angular/core";
import Swiper from "swiper";
import { SwiperOptions } from "swiper/types";

export function ensureSwiper(
	ref: ElementRef | undefined,
	config: SwiperOptions
): Swiper | undefined {
	const el = ref?.nativeElement;
	if (!el) return undefined;
	if (el.swiper && !el.swiper.destroyed) {
		el.swiper.update();
		return el.swiper;
	}
	return new Swiper(el, {
		observer: true,
		observeSlideChildren: true,
		...config
	});
}

export function destroySwiper(ref: ElementRef | undefined): void {
	ref?.nativeElement?.swiper?.destroy(true, true);
}
